import type { CandlestickData, LineData, UTCTimestamp } from 'lightweight-charts'

export function emaFromCandles(candles: CandlestickData[], period: number): LineData[] {
  const n = Math.max(1, Math.floor(period))
  const out: LineData[] = []
  if (!candles || candles.length < n) return out

  // Coleta closes/times válidos (finito e em ordem)
  const closes: Array<{ t: UTCTimestamp; c: number }> = []
  for (const c of candles) {
    const t = c.time as UTCTimestamp
    const v = Number(c.close)
    if (Number.isFinite(v)) closes.push({ t, c: v })
  }
  if (closes.length < n) return out

  const k = 2 / (n + 1)
  // seed com SMA dos primeiros n válidos
  let sum = 0
  for (let i = 0; i < n; i++) sum += closes[i].c
  let ema = sum / n
  out.push({ time: closes[n - 1].t, value: ema })
  for (let i = n; i < closes.length; i++) {
    const close = closes[i].c
    ema = (close - ema) * k + ema
    if (Number.isFinite(ema)) out.push({ time: closes[i].t, value: ema })
  }
  return out
}

export function rsiFromCandles(candles: CandlestickData[], period = 14): LineData[] {
  const n = Math.max(1, Math.floor(period))
  const out: LineData[] = []
  if (!candles || candles.length <= n) return out

  // Série de closes válidos
  const arr: Array<{ t: UTCTimestamp; c: number }> = []
  for (const c of candles) {
    const v = Number(c.close)
    if (Number.isFinite(v)) arr.push({ t: c.time as UTCTimestamp, c: v })
  }
  if (arr.length <= n) return out

  // Wilder's RSI com salvaguardas
  let gain = 0
  let loss = 0
  for (let i = 1; i <= n; i++) {
    const ch = arr[i].c - arr[i - 1].c
    if (ch >= 0) gain += ch; else loss -= ch
  }
  let avgGain = gain / n
  let avgLoss = loss / n
  const firstIdx = n
  const rs0 = avgLoss === 0 ? 100 : (avgGain / Math.max(1e-12, avgLoss))
  let rsi = 100 - 100 / (1 + rs0)
  out.push({ time: arr[firstIdx].t, value: Math.max(0, Math.min(100, rsi)) })
  for (let i = firstIdx + 1; i < arr.length; i++) {
    const ch = arr[i].c - arr[i - 1].c
    const g = ch > 0 ? ch : 0
    const l = ch < 0 ? -ch : 0
    avgGain = (avgGain * (n - 1) + g) / n
    avgLoss = (avgLoss * (n - 1) + l) / n
    const rs = avgLoss === 0 ? 100 : (avgGain / Math.max(1e-12, avgLoss))
    rsi = 100 - 100 / (1 + rs)
    const v = Math.max(0, Math.min(100, rsi))
    if (Number.isFinite(v)) out.push({ time: arr[i].t, value: v })
  }
  return out
}

// noop (removido clamp auxiliar)
